module.exports = __webpack_public_path__ + "static/offer-wireframe-2-faa745953bc621a530196a69eeee6c9c.jpg";